import React from "react";
//#region types
import { TranslationKeys } from "translations";
import { IconDefinitionConstants } from "utils/constants";
import { DisplayType } from "models/enums/style";
import { SupportTeamResponse } from "serviceHooks/useSupportTeamContent";
//#endregion
//#region components
import { ButtonBase } from "@mui/material";
import { Icon } from "components/common";
import TeamAvatarGroup from "./teamAvatarGroup";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import clsx from "clsx";
import { LocalizationHelperInstance } from "utils/helpers";

interface ContactSupportSectionProps {
  data: SupportTeamResponse | null;
  onCreateCase: () => void;
  title?: string;
  /** Leaves out the way to write a case, for when the popper already is one. */
  hideCreateCase?: boolean;
}

const ContactSupportSection: React.FC<ContactSupportSectionProps> = ({ data, onCreateCase, title, hideCreateCase }) => {
  const team = data?.team;
  const content = data?.content;
  const showPhone = data?.showPhone ?? false;
  const phoneNumber = content?.phoneNumber ?? "";

  const t = (field: keyof NonNullable<typeof content>, fallbackKey: string) =>
    content?.[field] || LocalizationHelperInstance.getFormattedMessage(fallbackKey);

  return (
    <div className={cssExports.contactSupportSection}>
      <div className={cssExports.contactSupportHeader}>
        <div className={cssExports.contactSupportTitle}>
          {title ?? LocalizationHelperInstance.getFormattedMessage(TranslationKeys.SupportIssue.ContactSupport)}
        </div>
        {team && team.members.length > 0 && (
          <div className={cssExports.contactSupportTeamBadge}>
            <span className={cssExports.contactSupportTeamLabel}>
              {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.SupportIssue.YourTeam)}
            </span>
            <TeamAvatarGroup members={team.members} />
          </div>
        )}
      </div>

      <div className={cssExports.contactSupportActions}>
        {hideCreateCase ? null : (
          <ButtonBase component="div" className={cssExports.contactSupportActionButton} onClick={onCreateCase}>
            <div className={cssExports.supportTeamActionCard}>
              <div className={cssExports.supportTeamActionIcon}>
                <Icon icon={IconDefinitionConstants.WCommentDots} displayType={DisplayType.Info} />
              </div>
              <div className={cssExports.supportTeamActionContent}>
                <div className={cssExports.supportTeamActionTitle}>
                  {t("sendMessageTitle", TranslationKeys.Common.SendMessage)}
                </div>
                <div className={cssExports.supportTeamActionSubtitle}>
                  {t("sendMessageSubtitle", TranslationKeys.SupportIssue.SupportCaseAnswerWaitTime)}
                </div>
              </div>
            </div>
          </ButtonBase>
        )}

        {showPhone && phoneNumber && (
          <div className={clsx(cssExports.supportTeamPhoneLink, cssExports.contactSupportActionButton)}>
            <div className={cssExports.supportTeamActionCard}>
              <div className={cssExports.supportTeamActionIcon}>
                <Icon icon={IconDefinitionConstants.WSupportCenter} displayType={DisplayType.Info} />
              </div>
              <div className={cssExports.supportTeamActionContent}>
                <div className={cssExports.supportTeamActionTitle}>
                  {t("callSupportTitle", TranslationKeys.Common.CallSupport)}
                </div>
                <div className={cssExports.supportTeamActionSubtitle}>
                  {t("callSupportSubtitle", TranslationKeys.Common.CallSupportSubtitle)}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ContactSupportSection;
